// Types
// Utils
import useFormatDateTime from '@/utils/hooks/format/useFormatDateTime';

import type { UserType } from '@/types/userType';

type DateCellProps = {
    date: string;
    timezone: UserType['settings']['timezone'];
    dateFormat: UserType['settings']['date_format'];
};

function DateCell({ date, timezone, dateFormat }: DateCellProps) {
    const { formatDateTime } = useFormatDateTime(timezone);
    return (
        <span className="font-GMedium text-xs">
            {date ? formatDateTime(date, dateFormat) : '-'}
        </span>
    );
}

export default DateCell;
